import { compose, withHandlers, withState } from 'recompose'

import NotificationModal from './component'

export default compose(
  withState('toggle', 'setToggle', true),
  withHandlers({
    changeSetToggle: ({setToggle}) => event => {
      setToggle(false)
    }
  })
)(NotificationModal)


// WEBPACK FOOTER //
// ./src/components/NotificationModalExp/index.js